var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('app-echart-bar',{key:_vm.chartKey,staticClass:"mb-2",staticStyle:{"height":"320px","width":"100%"},attrs:{"option-data":_vm.chartOption}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }